import React, {FC} from 'react';

import {Banner, BannerTypesEnum} from '../../../../../libs/shared/ui/src/components/banners/banner';
import {BannerCloseAction} from '../../../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerPrioritiesEnum} from '../../../../../libs/shared/ui/src/components/banners/bannersContext';
import {BannerText} from '../../../../../libs/shared/ui/src/components/banners/bannerText';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {IntegrationModel} from '../../../../models/api/integrationModel';

/*
 * Props.
 */

interface IntegrationEnabledBannerProps {
  integration: IntegrationModel;
  onDismissClick: () => void;
}

/*
 * Component.
 */

export const IntegrationEnabledBanner: FC<IntegrationEnabledBannerProps> = (props) => {
  const theme = useUserTheme();
  const {integration, onDismissClick} = props;

  return (
    <Banner
      bannerType={BannerTypesEnum.INLINE}
      priority={BannerPrioritiesEnum.INFORMATION}
      color={theme.palette.blue.shade40}
    >
      <BannerCloseAction onClick={onDismissClick} />
      <BannerText>The ${integration.name} integration has been enabled by an admin.</BannerText>
    </Banner>
  );
};
